import { render, staticRenderFns } from "./NftCard.vue?vue&type=template&id=69436e64&scoped=true&"
import script from "./NftCard.vue?vue&type=script&lang=js&"
export * from "./NftCard.vue?vue&type=script&lang=js&"
import style0 from "./NftCard.vue?vue&type=style&index=0&id=69436e64&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69436e64",
  null
  
)

export default component.exports